import { useAuth } from '@/contexts/auth-context';
import { api } from '@/lib/api';
import { useEffect } from 'react';

export function useOrg() {
  const { currentOrg, orgs, setCurrentOrg, setOrgs, isAuthenticated, isTenantUser } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || isTenantUser) return;
    // Only fetch once — skip if orgs already loaded
    if (orgs.length > 0) return;

    api.orgs.list().then((data) => {
      setOrgs(data);
      // Auto-select personal org if none selected
      if (!currentOrg && data.length > 0) {
        const personal = data.find((o: any) => o.is_personal);
        if (personal) setCurrentOrg(personal);
      }
    }).catch(() => {});
  }, [isAuthenticated, isTenantUser]);

  const switchOrg = async (orgId: string) => {
    await api.orgs.select(orgId);
    const org = orgs.find((o) => o.id === orgId);
    if (org) setCurrentOrg(org);
  };

  const isOwner = currentOrg?.my_role === 'owner';

  return { currentOrg, orgs, switchOrg, isOwner };
}
